import React, { useEffect, useState, Fragment } from 'react';
import MessageModal from '../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../Common';
import services from '../services';
import $ from 'jquery';
import authService from '../../Common/services';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Joi from '@hapi/joi'
import { NormAssignListingSchemaObject } from '../NormAssignSchema';
import { NormAssignSchemaObjectUpdate } from '../NormAssignSchema';
import { validateProperty, validate } from "../../Common";
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import Box from '@material-ui/core/Box';
import tokenService from '../../../Common/tokenDecoder';
import { MultiSelect } from '../../../Common/multiSelect';

const screenCode = 'NORMASSIGN';

export function NormAssignEdit(props) {
    const [groups, setGroups] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [estates, setEstates] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [configurationName, setConfigurationName] = useState();
    const [errors, setErrors] = useState({})
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [isEnable, setIsEnable] = useState(true);
    const [isHide, setIsHide] = useState(false);
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const [setIstableHidden] = useState(true);
    const [limit, setLimit] = useState(5);
    const [page, setPage] = useState(0);
    const [normDetails, setNormDetails] = useState([]);
    const [selectedOperationEntities, setSelectedOperationEntities] = useState([]);
    const [selectedCollectionPoints, setSelectedCollectionPoints] = useState([]);
    const [divisionEstateMap, setDivisionEstateMap] = useState({});
    const [normValue, setNormValue] = useState({
        groupID: 0,
        estate: [],
        configurationID: 0,
        divisionID: [],
        fromDate: new Date().toISOString().split('T')[0],
        toDate: new Date().toISOString().split('T')[0],
        isSundayEnabled: false,
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        configurationID: "0",
        fromDate: new Date().toISOString().split('T')[0],
        toDate: new Date().toISOString().split('T')[0],
        divisionID: "0",
    })
    const [updateValues, setUpdateValues] = useState({
        configurationValue: "",
        minValue: "",
        maxValue: ""
    })
    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };
    const schema = Joi.object(NormAssignListingSchemaObject).options({ allowUnknown: true })
    const schemaUpadete = Joi.object(NormAssignSchemaObjectUpdate).options({ allowUnknown: true })

    useEffect(() => {
        const navigationState = props.location && props.location.state;
        if (navigationState && navigationState.savedStatus) {
            setMessageModel({
                hidden: false,
                type: navigationState.savedStatus,
                disciption: navigationState.savedMessage || "Save success"
            });

            setTimeout(() => {
                setMessageModel(prevState => ({ ...prevState, hidden: true }));
            }, 2500);

            props.history.replace({
                pathname: props.location.pathname,
                state: undefined
            });
        }
    }, []);

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    useEffect(() => {
        getAllGroups();
    }, []);

    useEffect(() => {
        if (normValue.groupID != 0 || normValue.groupID != "") {
            getEstatesForDropdown();
        }
        setNormDetails([])
        setIsHide(false);
    }, [normValue.groupID]);

    useEffect(() => {
        if (selectedOperationEntities.length > 0) {
            trackPromise(getConfigurationNameForDropdown());
            trackPromise(getDivisionsForDropDown(selectedOperationEntities));
        } else {
            setDivisions({});
            setDivisionEstateMap({});
            setSelectedCollectionPoints([]);
            setNormValue(prev => ({
                ...prev,
                divisionID: []
            }));
        }
        setNormDetails([])
        setIsHide(false);
    }, [selectedOperationEntities])

    useEffect(() => {
        const selectedOperationEntityIDs = new Set(
            selectedOperationEntities.map(option => String(option.value))
        );

        const filteredCollectionPoints = selectedCollectionPoints.filter(option => {
            const relatedEstateID = option.estateID !== undefined
                ? String(option.estateID)
                : String(divisionEstateMap[option.value]);

            return selectedOperationEntityIDs.has(relatedEstateID);
        });

        if (filteredCollectionPoints.length !== selectedCollectionPoints.length) {
            setSelectedCollectionPoints(filteredCollectionPoints);
            setNormValue(prev => ({
                ...prev,
                divisionID: filteredCollectionPoints.map(option => parseInt(option.value, 10))
            }));
            setErrors(prev => ({ ...prev, divisionID: undefined }));
        }
    }, [divisionEstateMap, selectedOperationEntities]);

    useEffect(() => {
        setNormDetails([])
        setIsHide(false);
    }, [selectedCollectionPoints])

    useEffect(() => {
        setNormDetails([])
        setIsHide(false);
    }, [normValue.configurationID])

    useEffect(() => {
        setNormDetails([])
        setIsHide(false);
    }, [normValue.fromDate])

    useEffect(() => {
        setNormDetails([])
        setIsHide(false);
    }, [normValue.toDate])

    function handleGroupChange(target) {
        validateInputs(target);

        setNormValue({
            ...normValue,
            groupID: parseInt(target.value, 10),
            estate: [],
        })
        setSelectedOperationEntities([]);
        setSelectedCollectionPoints([]);
    }

    const handleOperationEntityChange = (selectedOptions) => {
        setSelectedOperationEntities(selectedOptions);
        setNormValue(prev => ({
            ...prev,
            estate: selectedOptions.map(option => parseInt(option.value, 10))
        }));
        setErrors(prev => ({ ...prev, estate: undefined }));
    };

    const handleOperationEntitySelectAll = (selectAll) => {
        if (selectAll) {
            const estateList = (multipleEstates && multipleEstates.length > 0) ? multipleEstates : estates;
            const allOptions = estateList.map(item => ({
                value: String(item.id),
                label: item.name
            }));
            setSelectedOperationEntities(allOptions);
            setNormValue(prev => ({
                ...prev,
                estate: allOptions.map(option => parseInt(option.value, 10))
            }));
        } else {
            setSelectedOperationEntities([]);
            setNormValue(prev => ({
                ...prev,
                estate: []
            }));
        }
        setErrors(prev => ({ ...prev, estate: undefined }));
    };

    const handleOperationEntityClear = () => {
        setSelectedOperationEntities([]);
        setSelectedCollectionPoints([]);
        setNormValue(prev => ({
            ...prev,
            estate: []
        }));
        setErrors(prev => ({ ...prev, estate: undefined }));
    };

    const handleCollectionPointChange = (selectedOptions) => {
        setSelectedCollectionPoints(selectedOptions);
        setNormValue(prev => ({
            ...prev,
            divisionID: selectedOptions.map(option => parseInt(option.value, 10))
        }));
        setErrors(prev => ({ ...prev, divisionID: undefined }));
    };

    const handleCollectionPointSelectAll = (selectAll) => {
        if (selectAll) {
            const allOptions = Object.entries(divisions).map(([value, label]) => ({
                value,
                label,
                estateID: divisionEstateMap[value]
            }));
            setSelectedCollectionPoints(allOptions);
            setNormValue(prev => ({
                ...prev,
                divisionID: allOptions.map(option => parseInt(option.value, 10))
            }));
        } else {
            setSelectedCollectionPoints([]);
            setNormValue(prev => ({
                ...prev,
                divisionID: []
            }));
        }
        setErrors(prev => ({ ...prev, divisionID: undefined }));
    };

    const handleCollectionPointClear = () => {
        setSelectedCollectionPoints([]);
        setNormValue(prev => ({
            ...prev,
            divisionID: []
        }));
        setErrors(prev => ({ ...prev, divisionID: undefined }));
    };

    function handleConfigurationNameChange(target) {
        validateInputs(target);

        setNormValue({
            ...normValue,
            configurationID: parseInt(target.value, 10),

        })
        setNormDetails([]);
    }

    function handleFromDateChange(target) {
        const newFromDate = target.value;
        const currentToDate = normValue.toDate;

        setNormValue(prevState => ({
            ...prevState,
            fromDate: newFromDate,
            toDate: new Date(currentToDate) < new Date(newFromDate) ? newFromDate : currentToDate
        }));
    }

    const handleToDateChange = (target) => {
        const toDate = new Date(target.value);
        const fromDate = new Date(normValue.fromDate);

        if (toDate < fromDate) {
            setErrors(prevErrors => ({
                ...prevErrors,
                toDate: 'To Date must be after From Date.'
            }));
        } else {
            setErrors(prevErrors => ({
                ...prevErrors,
                toDate: ''
            }));
            setNormValue(prevState => ({
                ...prevState,
                toDate: target.value
            }));
        }
    };

    function handleSundayToggle(e) {
        const checked = e.target.checked;

        setNormValue(prev => ({
            ...prev,
            isSundayEnabled: checked,
        }));
        setNormDetails([]);
        setIsHide(false);
    }

    function handleUpdateChange(e) {
        const target = e.target;
        const name = target.name;
        const value = target.value;

        setUpdateValues(prevValues => ({
            ...prevValues,
            [name]: value
        }));

        const errorMessage = validateProperty(target, NormAssignSchemaObjectUpdate);

        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: errorMessage || undefined
        }));
        if (["minValue", "maxValue", "configurationValue"].includes(name)) {
            if (/^[0-9]*$/.test(value) || value === '') {
                setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
            }
        }
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, NormAssignListingSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWNORMASSIGN');
        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDNORMASSIGN');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        const isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
        const isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode === 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isAddEditEnabled: isAddEditEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromTokenV2();
        if (token.operationEntities.length > 0) {
            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }
            setMultipleEstates(estateArray)

            setNormValue({
                ...normValue,
                groupID: token.groupID,
            })

        }
        else {
            setNormValue({
                ...normValue,
                groupID: token.groupID,
                estate: token.operationEntityID ? [token.operationEntityID] : []
            })
        }

        setNormValue({
            ...normValue,
            groupID: token.groupID,
            estate: token.operationEntityID ? [token.operationEntityID] : []
        });
        trackPromise(getAllGroups());
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    async function getAllGroups() {
        var data
        data = await groupService.getGroupsForDropdown();
        setGroups(data)
    }

    useEffect(() => {
    }, [multipleEstates]);

    async function getEstatesForDropdown() {
        try {
            const data = await services.getEstatesByGroupID(normValue.groupID);
            const token = tokenService.getUserDetailsFromTokenV2();
            const validEstateIds = token.operationEntities.map(entity => String(entity.OperationEntityID));

            let estateList = [];
            if (Array.isArray(data) && data.every(item => typeof item === 'object' && item.id && item.name)) {
                estateList = data;
            } else {
                estateList = data
                    .map((name, index) => name ? { id: String(index), name } : null)
                    .filter(item => item !== null);
            }
            const filteredEstates = estateList.filter(estate => validEstateIds.includes(String(estate.id)));

            setEstates(filteredEstates);
            setMultipleEstates(filteredEstates);
        } catch (error) {
            setEstates([]);
            setMultipleEstates([]);
            setMessageModel({
                hidden: false,
                type: "Error",
                disciption: "Failed to load operation entities. Please try again.",
            });
            setTimeout(() => {
                setMessageModel(prev => ({ ...prev, hidden: true }));
            }, 4000);
        }
    }

    async function getConfigurationNameForDropdown() {
        try {
            const firstEstateID = selectedOperationEntities[0]?.value;
            if (!firstEstateID || firstEstateID === '0') return;

            const data = await services.getConfigurationNames(firstEstateID);

            const configList = data
                .map((name, index) => name ? { id: index, name } : null)
                .filter(item => item !== null);

            setConfigurationName(configList);

            const newConfigID = configList.length > 0 ? configList[0].id : 0;
            setNormValue(prev => ({
                ...prev,
                configurationID: newConfigID,
            }));
            if (newConfigID !== 0) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    configurationID: undefined
                }));
            }

            setNormDetails([]);
            setIsHide(false);
        } catch (error) {
            setConfigurationName([]);
            setMessageModel({
                hidden: false,
                type: "Error",
                disciption: "Failed to load configuration names. Please try again.",
            });
            setTimeout(() => {
                setMessageModel(prev => ({ ...prev, hidden: true }));
            }, 4000);
        }
    }

    async function getDivisionsForDropDown(operationEntities = selectedOperationEntities) {
        let combinedDivisions = {};
        let newDivisionEstateMap = {};

        for (const estate of operationEntities) {
            if (estate.value && estate.value !== '0') {
                const data = await services.getDivisionByEstateID(estate.value);
                combinedDivisions = { ...combinedDivisions, ...data };
                Object.keys(data).forEach(divisionID => {
                    newDivisionEstateMap[divisionID] = estate.value;
                });
            }
        }
        setDivisions(combinedDivisions);
        setDivisionEstateMap(newDivisionEstateMap);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }
    function generateDropDownMenuForConfigurationName(data) {
        let items = [];
        if (data && Array.isArray(data)) {
            items = data.map(item => (
                <MenuItem key={item.id} value={item.id}>
                    {item.name}
                </MenuItem>
            ));
        } else if (data && typeof data === 'object') {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    async function handleSearch(e) {
        e.preventDefault();
        const searchPayload = {
            ...normValue,
            estate: selectedOperationEntities.map(option => parseInt(option.value, 10)),
            divisionID: selectedCollectionPoints.map(option => parseInt(option.value, 10))
        };

        const errorMessages = validate(schema, searchPayload);
        if (errorMessages) {
            setErrors(errorMessages);
            setIsHide(false);
            return;
        } else {
            setErrors({});
            setIsHide(true);
        }
        getSelectedDropdownValuesForReport(searchPayload);
        const response = await services.getNormDetails(searchPayload);
        if (response.length === 0 || response.statusCode === "Error") {
            setIsHide(false);
            setMessageModel({ hidden: false, type: "Error", disciption: response.message || "No records to display" });
            afterUnsuccessfulyChanged("Error");
            return;
        }

        let results = response;
        if (searchPayload.isSundayEnabled) {
            results = Array.isArray(response) ? response.filter(r => {
                try {
                    const d = new Date(r.estimatedDate);
                    return d.getDay() === 0;
                } catch (err) {
                    return false;
                }
            }) : [];

            if (results.length === 0) {
                setIsHide(false);
                setMessageModel({ hidden: false, type: "Error", disciption: "No Sunday records to display" });
                afterUnsuccessfulyChanged("Error");
                return;
            }
        }

        setNormDetails(results);
        setPage(0);
        destroyDataTable();
        createDataTable();
    }

    function afterUnsuccessfulyChanged(response) {
        if (response === "Error") {
            setTimeout(() => {
                setMessageModel({ hidden: true, type: "Error", disciption: "" });
            }, 1500);
        }
    }

    async function handleUpdate(e) {
        const { minValue, maxValue } = updateValues;
        if (parseFloat(minValue) > parseFloat(maxValue)) {
            setErrors({ minValue: "Min Value cannot be greater than Max Value." });
            return;
        }
        const errorMessages = validate(schemaUpadete, updateValues);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        setIsEnable(false);
        const response = await services.updateNewNorm(updateValues, normValue);

        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        setTimeout(() => {
            setMessageModel(prevState => ({ ...prevState, hidden: true }));
        }, 4000);
        afterSuccessfulyChanged(response.statusCode)
        function afterSuccessfulyChanged(response) {
            if (response === "Success") {
                setTimeout(() => {
                    props.history.push({ pathname: '/NormAssignEdit' })
                }, 4000);
                setNormDetails([]);
            }
        }
        setIsEnable(true);
        setIsHide(false)
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        const selectedEstates = Array.isArray(searchForm.estate)
            ? searchForm.estate.map(id => estates.find(e => String(e.id) === String(id))?.name).filter(Boolean).join(', ')
            : estates.find(estate => String(estate.id) === String(searchForm.estate))?.name || "0";

        const selectedDivisions = Array.isArray(searchForm.divisionID)
            ? searchForm.divisionID.map(id => divisions[id]).filter(Boolean).join(', ')
            : divisions[searchForm.divisionID] || "0";

        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID] || "0",
            estate: selectedEstates,
            configurationID: configurationName.find(c => c.id === searchForm.configurationID)?.name || "0",
            fromDate: searchForm.fromDate,
            toDate: searchForm.toDate,
            divisionID: selectedDivisions,
        });
    }

    function clearButton() {
        setIsEnable(true);
        const firstConfigID = configurationName.length > 0 ? configurationName[0].id : 0;
        setIsHide(false);
        setIsHide(false)
        setNormValue({
            groupID: normValue.groupID,
            estate: [],
            configurationID: firstConfigID,
            divisionID: [],
            fromDate: new Date().toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0]
        });
        setSelectedOperationEntities([]);
        setSelectedCollectionPoints([]);
        setUpdateValues({
            ...updateValues,
            configurationValue: "",
            minValue: "",
            maxValue: ""
        })
        setErrors({});
        setNormDetails([]);
        setPage(0);
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={isHide ? "Update Norm Assign" : "Norm Assign"}
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add Norm Assign"
                            path="NormAssignEdit/addEdit"
                        />

                        <div className="card-body">
                            <form onSubmit={(e) => handleSearch(e)} >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={!isEnable || !permissionList.isGroupFilterEnabled}
                                            value={normValue.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <MultiSelect
                                            items={(multipleEstates && multipleEstates.length > 0 ? multipleEstates : estates).map((item) => ({
                                                value: String(item.id),
                                                label: item.name
                                            }))}
                                            selectedValues={selectedOperationEntities}
                                            label="Operation Entity *"
                                            placeholder="Select Operation Entities"
                                            selectAllLabel="Select All Operation Entities"
                                            noOptionsText="No Operation Entities"
                                            limitTags={3}
                                            onToggleOption={handleOperationEntityChange}
                                            onSelectAll={handleOperationEntitySelectAll}
                                            onClearOptions={handleOperationEntityClear}
                                            getOptionLabel={option => option.label}
                                            isDisabled={!isEnable || !permissionList.isOperationEntityFilterEnabled}
                                        />
                                        {errors["estate"] && <FormHelperText error>{errors["estate"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <MultiSelect
                                            items={Object.entries(divisions).map(([value, label]) => ({
                                                value,
                                                label,
                                                estateID: divisionEstateMap[value]
                                            }))}
                                            selectedValues={selectedCollectionPoints}
                                            label="Collection Point *"
                                            placeholder="Select Collection Points"
                                            selectAllLabel="Select All Collection Points"
                                            noOptionsText="No Collection Points"
                                            limitTags={3}
                                            onToggleOption={handleCollectionPointChange}
                                            onSelectAll={handleCollectionPointSelectAll}
                                            onClearOptions={handleCollectionPointClear}
                                            getOptionLabel={option => option.label}
                                            isDisabled={!isEnable}
                                        />
                                        {errors["divisionID"] && <FormHelperText error>{errors["divisionID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="configurationID">Configuration Name *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="configurationID"
                                            id="configurationID"
                                            name="configurationID"
                                            disabled={!isEnable}
                                            value={normValue.configurationID}
                                            onChange={(e) => handleConfigurationNameChange(e.target)}>
                                            <MenuItem value="0">--Select Configuration Name--</MenuItem>
                                            {generateDropDownMenuForConfigurationName(configurationName)}
                                        </Select>
                                        {errors["configurationID"] && <FormHelperText error>{errors["configurationID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            value={normValue.fromDate}
                                            disabled={!isEnable}
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && <FormHelperText error>{errors["fromDate"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            value={normValue.toDate}
                                            disabled={!isEnable}
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputProps={{
                                                inputProps: {
                                                    min: normValue.fromDate,
                                                }
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && <FormHelperText error>{errors["toDate"]}</FormHelperText>}
                                    </div>

                                </div>
                                <div className="col-md pb-1">
                                    <label>Is Sunday Enabled</label>
                                    <div className="form-group row">
                                        <div className="col-md ">
                                            <input
                                                id="isDefault"
                                                switch="none"
                                                className="mr-2"
                                                type="checkbox"
                                                name="isDefault"
                                                checked={normValue.isSundayEnabled}
                                                onChange={(e) => handleSundayToggle(e)}

                                            />
                                            <label htmlFor="isDefault" data-on-label="Yes"
                                                data-off-label="No"></label>
                                            {errors["isDefault"] && <FormHelperText error>{errors["isDefault"]}</FormHelperText>}
                                        </div>
                                    </div>
                                </div>
                                {!isHide ? (
                                    <div className="card-footer">
                                        <input
                                            type="submit"
                                            className="btn btn-primary"
                                            value="View"
                                            onClick={e => trackPromise(handleSearch(e))}
                                        />
                                    </div>
                                ) : null}
                            </form>
                            {normDetails.length != 0 ?
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group row">
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="minValue">Min Value *</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    id="minValue"
                                                    name="minValue"
                                                    type="text"
                                                    onChange={handleUpdateChange}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 999,
                                                            maxLength: 3
                                                        }
                                                    }}
                                                />
                                                {errors["minValue"] && <FormHelperText error>{errors["minValue"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="maxValue">Max Value *</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    id="maxValue"
                                                    name="maxValue"
                                                    type="text"
                                                    onChange={handleUpdateChange}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    InputProps={{
                                                        inputProps: {
                                                            min: 0,
                                                            max: 999,
                                                            maxLength: 3
                                                        }
                                                    }}
                                                />
                                                {errors["maxValue"] && <FormHelperText error>{errors["maxValue"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1"></div>
                                        </div>
                                        {isHide ? (
                                            <div className="card-footer">
                                                <input
                                                    type="submit"
                                                    className="btn btn-primary"
                                                    value="Update"
                                                    onClick={e => trackPromise(handleUpdate(e))}
                                                />
                                                <input
                                                    type="reset"
                                                    className="btn btn-warning pull-right"
                                                    value="CLEAR"
                                                    onClick={clearButton}
                                                />
                                            </div>
                                        ) : null}
                                        <div>
                                            <Box display="flex" justifyContent="flex-end" p={2}>
                                                <TableContainer component={Paper} style={{ width: '100%' }}>
                                                    <Table aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell
                                                                    align="center"
                                                                    style={{ fontWeight: "bold", width: '20%', padding: "2px 6px" }}
                                                                >
                                                                    Collection Point
                                                                </TableCell>
                                                                <TableCell
                                                                    align="center"
                                                                    style={{ fontWeight: "bold", width: '20%', padding: "2px 6px" }}
                                                                >
                                                                    Estimated Date
                                                                </TableCell>
                                                                {/* <TableCell
                                                                    align="center"
                                                                    style={{ fontWeight: "bold", width: '30%', padding: "2px 6px" }}
                                                                >
                                                                    Configuration Value
                                                                </TableCell> */}
                                                                <TableCell
                                                                    align="center"
                                                                    style={{ fontWeight: "bold", width: '15%', padding: "2px 6px" }}
                                                                >
                                                                    Min Value
                                                                </TableCell>
                                                                <TableCell
                                                                    align="center"
                                                                    style={{ fontWeight: "bold", width: '15%', padding: "2px 6px" }}
                                                                >
                                                                    Max Value
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {normDetails.slice(page * limit, page * limit + limit)

                                                                .map((row) => (
                                                                    <TableRow key={`${row.collectionPointName}-${row.estimatedDate}-${row.configurationHistoryID}`}>
                                                                        <TableCell
                                                                            align='center'
                                                                            style={{ width: '20%', padding: "2px 6px" }}
                                                                        >
                                                                            {row.collectionPointName == null ? '-' : row.collectionPointName}
                                                                        </TableCell>
                                                                        <TableCell
                                                                            align='center'
                                                                            style={{ width: '20%', padding: "2px 6px" }}
                                                                        >
                                                                            {row.estimatedDate.split('T')[0]}
                                                                        </TableCell>
                                                                        {/* <TableCell
                                                                            align='center'
                                                                            style={{ width: '30%', padding: "2px 6px" }}
                                                                        >
                                                                            {row.configurationValue == 0 ? '-' : row.configurationValue}
                                                                        </TableCell> */}
                                                                        <TableCell
                                                                            align='center'
                                                                            style={{ width: '15%', padding: "2px 6px" }}
                                                                        >
                                                                            {row.minValue == 0 ? '-' : row.minValue}
                                                                        </TableCell>
                                                                        <TableCell
                                                                            align='center'
                                                                            style={{ width: '15%', padding: "2px 6px" }}
                                                                        >
                                                                            {row.maxValue == 0 ? '-' : row.maxValue}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                        </TableBody>
                                                    </Table>
                                                    <TablePagination
                                                        component="div"
                                                        count={normDetails.length}
                                                        onChangePage={handlePageChange}
                                                        onChangeRowsPerPage={handleLimitChange}
                                                        page={page}
                                                        rowsPerPage={limit}
                                                        rowsPerPageOptions={[5, 10, 25]}
                                                    />
                                                </TableContainer>
                                            </Box>
                                        </div>
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    )
}


